import { computed, type ComputedRef, type Ref } from 'vue'

import { useConfig } from '@/composables/config'
import { useGetExternalUrl } from '@/composables/url-helpers'
import { useTr } from '@/composables/use-tr'
import { ROUTE_NAMES } from '@/router/constants'
import { useAppStore } from '@/store/app-store'
import type { APIGameType } from '@/types'

export function useShareData(game: Ref<APIGameType | undefined>): ComputedRef<ShareData> {
    const { VUE_APP_HOST_URL } = useConfig()
    const getExternalUrl = useGetExternalUrl()
    const appStore = useAppStore()
    const tr = useTr()

    const shareData = computed(() => {
        const url =
            VUE_APP_HOST_URL +
            getExternalUrl({
                name: ROUTE_NAMES.GAME_PAGE,
                params: {
                    game: game.value?.hru,
                },
            })
        const description = tr('gameContainer.share_game_description', { title: game.value?.title ?? '' })

        return {
            title: game.value?.title,
            text: appStore.platform === 'ios' ? `${description} ${url}` : description,
            url,
        }
    })

    return shareData
}
